<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/receivable-account">Receitas</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Nova receita</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div>
            <form @submit="save">
                <div class="row mt-4">
                    <div class="col-xl-12 col-md-12 col-sm-12">
                        <div class="card shadow mb-1">
                            <!-- Card Header - Dropdown -->
                            <div class="card-header text-primary">Informações do lançamento</div>
                            <div class="card-body">

                                <div class="row">
                                    <div class="col-xl-9 col-md-9 col-sm-12 mt-1">
                                        <label for="">Cliente*</label>
                                        <input type="text" class="form-control" placeholder="Selecione um cliente"
                                            v-model="receivable_account.client_name" readonly
                                            @click="showModalSelectClient">
                                    </div>
                                    <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                        <label for="">&nbsp;</label><br>
                                        <button type="button" @click="showModalSelectClient"
                                            class="btn btn-success width100"><i class="fa fa-search"></i> Pesquisar
                                            cliente</button>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-xl-8 col-md-8 col-sm-12 mt-1">
                                        <label for="">Descrição do lançamento*</label>
                                        <input type="text" class="form-control" placeholder="Pagamento referente à..."
                                            v-model="receivable_account.description">
                                    </div>
                                    <div class="col-xl-4 col-md-6 col-sm-12 mt-1">
                                        <label for="">Data da competência*</label>
                                        <input type="date" class="form-control"
                                            v-model="receivable_account.competence_date">
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                        <label for="">Valor do lançamento*</label>
                                        <input type="text" class="form-control" v-model.lazy="receivable_account.amount"
                                            v-money="money">
                                    </div>
                                    <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                        <label for="">Desconto(%)*</label>
                                        <input type="text" class="form-control"
                                            v-model.lazy="receivable_account.discount" v-money="percentage">
                                    </div>
                                    <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                        <label for="">Multa (R$)*</label>
                                        <input type="text" class="form-control" v-model.lazy="receivable_account.fine"
                                            v-money="money">
                                    </div>
                                    <div class="col-xl-3 col-md-3 col-sm-12 mt-1">
                                        <label for="">Juros(% a.m)*</label>
                                        <input type="text" class="form-control"
                                            v-model.lazy="receivable_account.interest" v-money="percentage">
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-lg-6 col-sm-6 col-xs-12">
                                        <label for="">Categoria*</label>
                                        <multiselect v-model="category_multiselect" :options="categories_options"
                                            :custom-label="categoryWithLang" placeholder="Selecione uma opção"
                                            :select-label="'Clique para selecionar'"
                                            :deselect-label="'Clique para remover'" @select="handleSelectCategory">

                                            <template #noResult>
                                                Nenhuma categoria encontrada.
                                            </template>
                                        </multiselect>
                                    </div>
                                    <div class="col-lg-6 col-sm-6 col-xs-12">
                                        <label for="">Código de referência</label>
                                        <input type="text" class="form-control" placeholder="Ex: 0001"
                                            v-model="receivable_account.cod_reference">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card shadow mt-4" v-if="services.length > 0">
                    <!-- Card Header - Accordion -->
                    <a href="#collapseCardServices" class="d-block card-header py-3" data-toggle="collapse" role="button"
                        aria-expanded="true" aria-controls="collapseCardServices">
                        <h6 class="m-0 text-primary">Serviços atrelados</h6>
                    </a>
                    <!-- Card Content - Collapse -->
                    <div class="collapse show" id="collapseCardServices">
                        <div class="card-body">
                           <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12">
                                        <div class="table-responsive">
                                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Serviço</th>
                                                        <th class="text-center">Valor</th>
                                                        <th class="text-center">Colaboradores</th>
                                                        <th class="text-center">Pró-labore</th>
                                                        <th class="text-center">Emissão NF</th>
                                                        <th class="text-center">Contrato assinado</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(service, index) in services"
                                                        :key="service.id">
                                                        <td>{{ index + 1 }}</td>
                                                        <td>{{ service.name_service }} </td>
                                                        <td class="text-center">{{ service.amount_formatted }}
                                                        </td>
                                                        <td class="text-center">{{ service.employees }} </td>
                                                        <td class="text-center">{{ service.pro_labore ? 'Sim' : 'Não' }}
                                                        </td>
                                                        <td class="text-center">{{ service.emission_nf ? 'Sim' : 'Não'
                                                            }} </td>
                                                        <td class="text-center">{{ service.signed_contract ? 'Sim' :
                                                            'Não' }} </td>
                                                        <td>{{ service.phone_formatted ? service.phone_formatted : '-'
                                                        }}
                                                        </td>
                                                    </tr>
                                                    <tr v-show="services.length > 0">

                                                        <td colspan="9" class="text-left">Total em serviços: <strong>
                                                                {{ total_service }}</strong></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-xl-12 col-md-12 col-sm-12">
                        <div class="card shadow mb-4">
                            <!-- Card Header - Dropdown -->
                            <div class="card-header text-primary">Condições de pagamento</div>
                            <div class="card-body">
                                <div class="row mb-2">
                                    <div class="col-md-2 col-xl-2 col-sm-12">
                                        Repetir lançamento?<br> <input type="checkbox" class="flipswitch flipswitch-repeat"
                                            @change="handleCheckboxRepeat">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-2 col-xl-2 col-sm-12 mt-1" v-if="receivable_account.repeat">
                                        <label for="">Cobrar sempre no*</label>
                                        <multiselect v-model="day_generate_receivable_multiselect"
                                            :options="day_generate_receivable_options" placeholder="Selecione uma opção"
                                            :select-label="'Clique para selecionar'"
                                            :deselect-label="'Clique para remover'"
                                            :custom-label="dayGenerateReceivableWithLang"
                                            @select="handleSelectDayGenerateReceivable">
                                            <template #noResult>
                                                Nenhum dia encontrado.
                                            </template>
                                        </multiselect>
                                    </div>
                                    <div class="col-md-2 col-xl-2 col-sm-12 mt-1" v-if="!receivable_account.repeat">
                                        <label for="">Parcelamento*</label>
                                        <multiselect v-model="installment_multiselect" :options="installments_options"
                                            placeholder="Selecione uma opção" :select-label="'Clique para selecionar'"
                                            :deselect-label="'Clique para remover'" :custom-label="installmentWithLang"
                                            @select="handleSelectInstallment">
                                            <template #noResult>
                                                Nenhum parcelamento encontrado.
                                            </template>
                                        </multiselect>
                                    </div>
                                    <div class="col-md-2 col-xl-2 col-sm-12 mt-1">
                                        <label v-if="receivable_account.installment == 1 && !receivable_account.repeat"
                                            for="">Vencimento*</label>
                                        <label v-if="receivable_account.installment > 1 || receivable_account.repeat"
                                            for="">Primeiro
                                            vencimento*</label>
                                        <input type="date" class="form-control" v-model="receivable_account.due_date">
                                    </div>
                                    <div class="col-md-2 col-xl-2 col-sm-12 mt-1"
                                        v-if="receivable_account.installment > 1 || receivable_account.repeat">
                                        <label for="">Intervalo entre parcelas*</label>
                                        <multiselect v-model="interval_recurrence_multiselect"
                                            :options="interval_recurrence_options" placeholder="Selecione uma opção"
                                            :select-label="'Clique para selecionar'"
                                            :deselect-label="'Clique para remover'"
                                            :custom-label="intervalRecurrenceWithLang"
                                            @select="handleSelectIntervalRecurrence">
                                            <template #noResult>
                                                Nenhum intervalo encontrado.
                                            </template>
                                        </multiselect>

                                    </div>
                                    <div class="col-md-2 col-xl-2 col-sm-12 mt-1">
                                        <label for="">Forma de pagamento*</label>
                                        <multiselect v-model="method_multiselect" :options="methods_options"
                                            :custom-label="methodWithLang" placeholder="Selecione uma opção"
                                            :select-label="'Clique para selecionar'"
                                            :deselect-label="'Clique para remover'" @select="handleSelectMethod">

                                            <template #noResult>
                                                Nenhuma forma de pagamento encontrada.
                                            </template>
                                        </multiselect>
                                    </div>
                                    <div class="col-md-2 col-xl-2 col-sm-12 mt-1">
                                        <label for="">Conta de pagamento*</label>
                                        <multiselect v-model="bank_multiselect" :options="banks_options"
                                            :custom-label="bankWithLang" placeholder="Selecione uma opção"
                                            :select-label="'Clique para selecionar'"
                                            :deselect-label="'Clique para remover'" @select="handleSelectBank">

                                            <template #noResult>
                                                Nenhuma conta encontrada.
                                            </template>
                                        </multiselect>
                                    </div>
                                    <div class="col-md-2 col-xl-2 col-sm-12 mt-1" v-if="register_bacen">
                                        <label for="">Registrar BACEN</label>
                                        <multiselect v-model="register_bacen_multiselect"
                                            :options="register_bacen_options" :custom-label="registerBacenWithLang"
                                            placeholder="Selecione uma opção" :select-label="'Clique para selecionar'"
                                            :deselect-label="'Clique para remover'" @select="handleSelectBank">

                                            <template #noResult>
                                                Nenhuma opção encontrada.
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="row mb-4 mt-3">
                                    <div class="col-lg-12 col-xs-12 col-sm-12">
                                        <label for="">Observações</label>
                                        <editorText @update-text="updateObservation"
                                            :modelValue="receivable_account.observation"
                                            placeholderSend="Sem observações">
                                        </editorText>
                                    </div>
                                </div>
                                <br>
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12">
                                        <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                                class="fa fa-save"></i>
                                            Cadastrar</button>
                                        <router-link to="/receivable-account" class="btn btn-danger ml-3"><i
                                                class="fa fa-times"></i>
                                            Cancelar</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

    </div>
    <div id="modalDisplaySelectClient" class="modal" :style="{ display: modalDisplaySelectClient }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="updateFile">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newFileLabel">Selecionar cliente do lançamento <button
                                    type="button" class="btn btn-success btn-sm" @click="newClient()"><i
                                        class="fa fa-plus"></i>
                                    Novo cliente</button></h5>
                            <button type="button" class="close" @click="closeModalSelectClient()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-2 col-lg-2 col-sm-12">
                                    <label for="">Matrícula</label>
                                    <input type="text" class="form-control" placeholder="Ex: 123"
                                        v-model="advanced_search.mat">
                                </div>
                                <div class="col-md-4 col-lg-4 col-sm-12">
                                    <label for="">Nome / Razão Social</label>
                                    <input type="text" class="form-control" placeholder="Ex: José da Silva"
                                        v-model="advanced_search.name">
                                </div>
                                <div class="col-md-4 col-lg-4 col-sm-12">
                                    <label for="">Documento</label>
                                    <input type="text" class="form-control" placeholder="Ex: xxx.xxx.xxx-xx"
                                        v-model="advanced_search.document">
                                </div>
                                <div class="col-md-2 col-lg-2 col-sm-12">
                                    <label for="">&nbsp;</label><br>
                                    <button type="button" class="btn btn-info width100" @click="searchClient"><i
                                            class="fa fa-search"></i> Pesquisar</button>
                                </div>
                            </div>

                            <hr>
                            <div class="row">
                                <div class="col-md-12 col-sm-12 col-xs-12">
                                    <div class="table-responsive limitHeight">
                                        <table class="table" id="dataTable" width="100%" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Nome / Documento</th>
                                                    <th>E-mail</th>
                                                    <th class="text-center align-middle">Status</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(client, index) in clients" :key="client.id">
                                                    <td class="text-center align-middle">{{ index + 1 }}</td>
                                                    <td class="align-middle">{{ client.name }}<br>{{ client.document_formatted }} </td>
                                                    <td class="align-middle">{{ client.email ? client.email : '-' }}</td>
                                                    <td class="text-center align-middle"><span class="badge"
                                                            :class="badgeStatus(client.status.status)">{{
                                                                client.status.status }}</span></td>
                                                    <td class="align-middle">
                                                        <button type="button" class="btn btn-success btn-sm"
                                                            @click="selectClient(client)"><i class="fa fa-check"></i>
                                                            Selecionar</button>

                                                    </td>
                                                </tr>
                                                <tr v-if="clients.length > 0 && page > 1">
                                                    <td colspan="4" class="align-middle text-center pt-5"> <button
                                                            @click="searchClient()" class="btn btn-info btn-sm"
                                                            :disabled="!buttonPagination"><i class="fa fa-spinner"></i>
                                                            Carregar
                                                            mais registros</button></td>
                                                </tr>
                                                <tr v-show="clients.length <= 0">
                                                    <td colspan="7" class="text-center">Nenhum registro
                                                        encontrado</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger" @click="closeModalSelectClient()"><i
                                    class="fa fa-times"></i> Fechar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div id="modalDisplayEditFile" class="modal" :style="{ display: modalDisplayEditFile }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <form @submit="saveClient">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newFileLabel">Novo cliente</h5>
                            <button type="button" class="close" @click="closeModalNewClient()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row" v-if="enable_error_list">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <div class="alert alert-danger">
                                        <ol>
                                            <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-2 col-md-2 col-sm-12">
                                    <label for="">Matrícula</label>
                                    <div class="input-group mb-3">
                                        <input type="text" class="form-control" placeholder="Ex: 1"
                                            v-model="client.mat">
                                    </div>
                                </div>
                                <div class="col-xl-4 col-md-4 col-sm-12">
                                    <label for="">CPF / CNPJ*</label>
                                    <div class="input-group mb-3">
                                        <input type="text" class="form-control" placeholder="Ex: xxx.xxx.xxx-xx"
                                            v-model="client.document" v-mask="['###.###.###-##', '##.###.###/####-##']">

                                    </div>
                                </div>
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">Nome / Razão Social*</label>
                                    <input type="text" class="form-control" placeholder="Ex: José da Silva Lima"
                                        v-model="client.name">
                                </div>
                            </div>

                            <div class="row mt-2">
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">E-mail</label>
                                    <input type="text" class="form-control" placeholder="Ex: usuario@dominio.com"
                                        v-model="client.email">
                                </div>
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">Telefone*</label>
                                    <input type="text" class="form-control" v-model="client.phone"
                                        v-mask="['(##) ####-####', '(##) #####-####']" placeholder="(xx)x.xxxx-xxxx">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-4 col-md-4 col-sm-12">
                                    <label for="">CEP</label>

                                    <div class="input-group mb-3">
                                        <input type="text" class="form-control" placeholder="Ex: xxxxx-xxx"
                                            v-model="client.zipcode" v-mask="['#####-###']">
                                        <div class="input-group-append">
                                            <button class="btn btn-success" type="button" id="button-addon2"
                                                @click="searchZipcode()"><i class="fa fa-search"></i>Buscar
                                                CEP</button>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">Endereço*</label>
                                    <input type="text" class="form-control" placeholder="Ex: Av. Paulista"
                                        v-model="client.street">
                                </div>
                                <div class="col-xl-2 col-md-2 col-sm-12">
                                    <label for="">Nº</label>
                                    <input type="text" class="form-control" placeholder="Ex: 100"
                                        v-model="client.number_street">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">Complemento</label>
                                    <input type="text" class="form-control" placeholder="Ex: Próximo à...."
                                        v-model="client.complement">
                                </div>
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">Bairro</label>
                                    <input type="text" class="form-control" placeholder="Ex: Centro"
                                        v-model="client.district">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">Cidade</label>
                                    <input type="text" class="form-control" placeholder="Ex: São Paulo"
                                        v-model="client.city">
                                </div>
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">UF</label>
                                    <input type="text" class="form-control" placeholder="Ex: SP" v-model="client.uf">
                                </div>
                            </div>

                            <div class="row mt-2 mb-4">
                                <div class="col-lg-12 col-xs-12 col-sm-12">
                                    <label for="">Observações</label>
                                    <editorText @update-text="updateObservation" :modelValue="client.observation"
                                        placeholderSend="Sem observações" ref="myChild">
                                    </editorText>
                                </div>
                            </div>
                            <br>


                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger"
                                @click="closeModalNewClient()">Cancelar</button>
                            <button type="submit" class="btn btn-info saveFile" :disabled='!isDisabledNewClient'><i
                                    class="fa fa-save"></i>
                                Cadastrar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import editorText from '../util/editor-text.vue';
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
import Multiselect from 'vue-multiselect'


import 'vue-loading-overlay/dist/css/index.css';
import { loadZipcode } from '@/api-external';
import { capitalize } from '@/util';

export default {
    directives: { money: VMoney, mask },
    components: { Loading, editorText, Multiselect },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            clients: [],
            page: 1,
            last_page: 1,
            total_itens: 0,
            category_multiselect: '',
            bank_multiselect: '',
            register_bacen_multiselect: { type: '1', value: 'Sim' },
            method_multiselect: '',
            day_generate_receivable_multiselect: { type: '1', value: '1º dia do mês' },
            installment_multiselect: { type: '1', value: 'À vista' },
            interval_recurrence_multiselect: { type: 'monthly', value: 'Mensal' },
            categories_options: [],
            banks_options: [],
            modalDisplaySelectClient: 'none',
            modalDisplayEditFile: 'none',
            categories: {},
            banks: {},
            services: {},
            service_amount: 0,
            total_service: 0.00,
            register_bacen: false,
            day_generate_receivable_options: [
                { type: 1, value: '1º dia do mês' },
                { type: 2, value: '2º dia do mês' },
                { type: 3, value: '3º dia do mês' },
                { type: 4, value: '4º dia do mês' },
                { type: 5, value: '5º dia do mês' },
                { type: 6, value: '6º dia do mês' },
                { type: 7, value: '7º dia do mês' },
                { type: 8, value: '8º dia do mês' },
                { type: 9, value: '9º dia do mês' },
                { type: 10, value: '10º dia do mês' },
                { type: 11, value: '11º dia do mês' },
                { type: 12, value: '12º dia do mês' },
                { type: 13, value: '13º dia do mês' },
                { type: 14, value: '14º dia do mês' },
                { type: 15, value: '15º dia do mês' },
                { type: 16, value: '16º dia do mês' },
                { type: 17, value: '17º dia do mês' },
                { type: 18, value: '18º dia do mês' },
                { type: 19, value: '19º dia do mês' },
                { type: 20, value: '20º dia do mês' },
                { type: 21, value: '21º dia do mês' },
                { type: 22, value: '22º dia do mês' },
                { type: 23, value: '23º dia do mês' },
                { type: 24, value: '24º dia do mês' },
                { type: 25, value: '25º dia do mês' },
                { type: 26, value: '26º dia do mês' },
                { type: 27, value: '27º dia do mês' },
                { type: 28, value: '28º dia do mês' },

            ],
            installments_options: [
                { type: 1, value: 'À vista' },
                { type: 2, value: '2x' },
                { type: 3, value: '3x' },
                { type: 4, value: '4x' },
                { type: 5, value: '5x' },
                { type: 6, value: '6x' },
                { type: 7, value: '7x' },
                { type: 8, value: '8x' },
                { type: 9, value: '9x' },
                { type: 10, value: '10x' },
                { type: 11, value: '11x' },
                { type: 12, value: '12x' },
            ],
            methods_options: [
                { type: 'ticket_pix', value: 'Boleto-Pix' },
                { type: 'pix', value: 'PIX' },
                { type: 'ticket', value: 'Boleto' },
                { type: 'money', value: 'Dinheiro' },
                { type: 'other', value: 'Outros' }
            ],
            register_bacen_options: [
                { type: '1', value: 'Sim' },
                { type: '0', value: 'Não' }
            ],
            interval_recurrence_options: [
                { type: 'monthly', value: 'Mensal' },
                { type: 'bimonthly', value: 'Bimestral' },
                { type: 'quarterly', value: 'Trimestral' },
                { type: 'semiannual', value: 'Semestral' },
                { type: 'annual', value: 'Anual' }
            ],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            percentage: {
                decimal: '.',
                thousands: '',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            receivable_account: {
                client_id: '',
                client_name: '',
                description: '',
                competence_date: '',
                amount: '',
                category_id: '',
                installment: 1,
                due_date: '',
                method: '',
                bank_id: '',
                cod_reference:'',
                register_bacen: '1',
                interval_recurrence: 'monthly',
                type: 'u',
                day_generate_receivable: 1,
                repeat: false,
                observation: '',
                discount: '0.00',
                fine: 'R$ 2,00',
                interest: '1.00'
            },
            advanced_search: {
                mat: '',
                name: '',
                document: ''
            },
            client: {
                mat: '',
                document: '',
                name: '',
                birthday: '',
                gender: '',
                phone: '',
                email: '',
                rg: '',
                issuing_body: '',
                uf_issuing_body: '',
                date_dispatch: '',
                name_father: '',
                name_mother: '',
                number_registration_voter: '',
                status_civil: '',
                pis_pasep: '',
                ethnicity: '',
                education: '',
                occupation: '',
                zipcode: '',
                street: '',
                number_street: '',
                complement: '',
                district: '',
                city: '',
                uf: '',
                observation: ''
            },
            enable_error_list: false,
            errors: []
        }
    },

    computed: {
        isDisabled: function () {
            return this.receivable_account.client_id != '' && this.receivable_account.description != '' && this.receivable_account.competence_date != '' && this.receivable_account.amount != '' && this.receivable_account.category_id != '';
        },
        isDisabledNewClient: function () {
            return this.client.document != '' && this.client.name != '' && this.client.phone != '';
        }
    },
    mounted() {
        this.isLoading = false;
        const response_categories = this.getCategories();
        response_categories.then(() => {
            this.categories_options = this.categories.map(item => ({
                key: item.id,
                value: item.name
            }));

        });

        const response_banks = this.getBank();
        response_banks.then(() => {
            this.banks_options = this.banks.map(item => ({

                key: item.id,
                value: 'Conta: ' + capitalize(item.name)
            }));
        });

    },
    methods: {
        onCancel() { },
        badgeStatus(status) {
            if (status == 'Aguardando cadastro domínio') {
                return 'badge-danger';
            } else if (status == 'Aguardando assinatura contrato') {
                return 'badge-warning';
            } else if (status == 'Aguardando parametrização domínio') {
                return 'badge-info';
            } else if (status == 'Ativo') {
                return 'badge-success';
            } else if (status == 'Inativo' || status == 'Inadiplente') {
                return 'badge-danger';
            }
            return 'badge-info';
        },
        async getCategories() {
            this.isLoading = true;
            const response = api.get('/categoryAll')
                .then((response) => {
                    this.categories = response.data.data;
                    this.isLoading = false;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
            return response;
        },
        async getBank() {
            this.isLoading = true;
            this.isLoading = true;
            const response = api.get('/bank-account')
                .then((response) => {
                    this.banks = response.data.data;
                    this.isLoading = false;
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
            return response;
        },
        handleSelectCategory(option) {
            this.receivable_account.category_id = option.key;

        },
        handleSelectBank(option) {
            this.receivable_account.bank_id = option.key;
            this.checkRegisterBacen();

        },
        handleSelectRegisterBacen(option) {
            this.receivable_account.register_bacen = option.key;
        },
        handleSelectMethod(option) {
            this.receivable_account.method = option.type;
            this.checkRegisterBacen();
        },
        handleSelectDayGenerateReceivable(option) {
            this.receivable_account.day_generate_receivable = option.type;
        },
        handleSelectInstallment(option) {
            this.receivable_account.installment = option.type;
            if (this.receivable_account.installment == 1) {
                this.receivable_account.type = 'u';
            } else {
                this.receivable_account.type = 'p';
            }
        },
        handleSelectIntervalRecurrence(option) {
            this.receivable_account.interval_recurrence = option.type;
        },
        handleCheckboxRepeat(event) {
            if (event.target.checked) {
                this.receivable_account.repeat = true;
                this.receivable_account.type = 'p';
            } else {
                this.receivable_account.repeat = false;
                if(this.receivable_account.installment > 1){
                    this.receivable_account.type = 'p';
                }else{
                    this.receivable_account.type = 'u';
                }
            }
        },
        categoryWithLang({ value }) {
            return value;
        },
        bankWithLang({ value }) {
            return value;
        },
        registerBacenWithLang({ value }) {
            return value;
        },
        methodWithLang({ value }) {
            return value;
        },
        dayGenerateReceivableWithLang({ value }) {
            return value;
        },
        installmentWithLang({ value }) {
            return value;
        },
        intervalRecurrenceWithLang({ value }) {
            return value;
        },
        searchZipcode() {
            this.isLoading = true;
            if (this.client.zipcode.length > 0) {
                let zipcode = this.client.zipcode.replace(/\D/g, '');
                loadZipcode(zipcode).then((response) => {
                    this.client.street = response.street;
                    this.client.district = response.neighborhood;
                    this.client.city = response.city;
                    this.client.uf = response.state;
                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;
                });
            } else {
                 this.isLoading = false;
                this.$notify({
                    title: "Informação",
                    text: "Informe um CEP válido",
                    type: 'info'
                });
            }
        },
        searchClient() {
            if (this.advanced_search.mat == '' && this.advanced_search.name == '' && this.advanced_search.document == '') {
                this.$notify({
                    title: "Falha",
                    text: "Informe um nome/razão social ou documento para pesquisar um cliente",
                    type: 'error'
                });
                return;
            }

            this.isLoading = true;

            api.get('/client', {
                params: {
                    'mat': this.advanced_search.mat,
                    'name': this.advanced_search.name,
                    'document': this.advanced_search.document,
                }
            })
                .then((response) => {
                    this.isLoading = false;
                    this.last_page = response.data.last_page;
                    if (this.page <= 1) {
                        this.clients = response.data.data;
                    } else {
                        this.clients = this.clients.concat(response.data.data);
                    }

                    if (this.page < response.data.last_page) {
                        this.page++;
                    } else {
                        this.page = 1;
                    }

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        selectClient(client) {
            this.receivable_account.client_id = client.id;
            this.receivable_account.client_name = client.name + ' / ' + client.document_formatted;
            this.closeModalSelectClient();
            this.searchServiceClient();
            this.$notify({
                title: "Sucesso",
                text: "Cliente selecionado com sucesso!",
                type: 'success'
            });
        },

        newClient() {
            this.closeModalSelectClient();
            this.showModalNewClient();
        },
        updateObservation(observation) {
            this.client.observation = observation;
        },

        calculateTotalServices() {
            let sum = 0;
            this.services.forEach(service => {
                sum += parseFloat(service.amount);
            });

            this.total_service = new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        }).format(sum);
        },

        searchServiceClient() {
            this.services  = {};
            this.enable_error_list = false;
            this.isLoading = true;
            api.get('/client/' + this.receivable_account.client_id + '/service')
                .then((response) => {
                    this.isLoading = false;
                    if (response.data.services_client.length > 0) {
                        this.services = response.data.services_client;
                        let sumAux = 0.0;
                        this.services.forEach(service => {
                            sumAux += parseFloat(service.amount);
                        });
                        const formattedAmount = new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        }).format(sumAux);
                        this.receivable_account.amount = formattedAmount;
                        this.calculateTotalServices();
                    }
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status, error);
                })

        },

        saveClient(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.post('/client', this.client)
                .then((response) => {
                    this.receivable_account.client_id = response.data.client.id;
                    this.receivable_account.client_name = response.data.client.name + ' / ' + response.data.client.document_formatted;
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Cliente cadastrado com sucesso!",
                        type: 'success'
                    });
                    this.client = {};
                    this.closeModalNewClient();
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status, error);
                })

        },

        checkRegisterBacen() {
            this.register_bacen = false;
            if (this.receivable_account.method == 'pix' || this.receivable_account.method == 'ticket' || this.receivable_account.method == 'ticket_pix') {
                this.banks.forEach(bank => {
                    if (bank.id == this.receivable_account.bank_id) {
                        if (bank.gateway != '') {
                            this.register_bacen = true;
                        }
                    }
                });
            }

        },

        save(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.post('/receivable-account', this.receivable_account)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Receita cadastrada com sucesso!",
                        type: 'success'
                    });
                    this.receivable_account = {
                         client_id: '',
                        client_name: '',
                        description: '',
                        competence_date: '',
                        amount: '',
                        category_id: '',
                        installment: 1,
                        due_date: '',
                        method: '',
                        bank_id: '',
                        register_bacen: '1',
                        interval_recurrence: 'monthly',
                        type: 'u',
                        day_generate_receivable: 1,
                        repeat: false,
                        observation: '',
                        discount: '0.00',
                        fine: 'R$ 2,00',
                        interest: '1.00'
                    };
                    this.installment_multiselect = { type: '1', value: 'À vista' };
                    this.interval_recurrence_multiselect = { type: 'monthly', value: 'Mensal' };
                    this.bank_multiselect = '';
                    this.method_multiselect = '';
                    this.register_bacen_multiselect = { type: '1', value: 'Sim' };
                    this.services = {};
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status, error);
                })

        },

        showModalSelectClient() {
            this.modalDisplaySelectClient = 'block';
        },
        closeModalSelectClient() {
            this.clients = [];
            this.advanced_search.mat = '';
            this.advanced_search.name = '';
            this.advanced_search.document = '';
            this.modalDisplaySelectClient = 'none';
        },

        showModalNewClient() {
            this.modalDisplayEditFile = 'block';
        },
        closeModalNewClient() {
            this.modalDisplayEditFile = 'none';
        },
    }
}
</script>

<style>
.width100 {
    width: 100%;
}

.modal {
    position: fixed;
    z-index: 1999;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
    background-color: #f5f5f5;
    margin: 3% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 65%;
}

.modal-header {
    color: #000;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}

.directory {
    color: #a70000;
}

.file {
    color: #000fe6;
}

.limitHeight {
    max-height: 500px;
    overflow-y: auto;
    scrollbar-color: darkblue lightgrey;
    border-bottom: 1px solid #e0e0e0;
}

.limitHeight table {
    width: 100%;
    /* Ensure the table fills the container width */
    border-collapse: collapse;
    /* Optional: for better table styling */
}

.flipswitch-repeat:after {
    left: 2%;
    content: "Não";
    background: #920000;
    color: #fff;
}

.flipswitch-repeat:checked:after {
    left: 53%;
    content: "Sim";
    background: #02855d;
    color: #fff;
}

@media (max-width: 576px) {
    .modal-content {
        width: 90% !important;
    }
}
</style>